import axios from "axios";

class Service {
  static loadLatestVersion() {
    return axios.get("/latest_version.json");
  }
}

export default Service;
